export default __webpack_public_path__ + "static/media/livingroom.32f05935.webp";